import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { WebsiteDropDownFilterComponent } from './website-drop-down-filter.component'
import { FormsModule } from '@angular/forms'



@NgModule({
  declarations: [WebsiteDropDownFilterComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule
  ],
  exports: [WebsiteDropDownFilterComponent]
})
export class WebsiteDropDownFilterModule { }
